/* fb-qty.js — Empire-independent driver for the classic product-page quantity
   stepper (snippets/quantity-selector.liquid, rendered by product-form.liquid).

   Empire's theme.js used to wire the [data-quantity-plus] / [data-quantity-minus]
   buttons to the [data-quantity-input]. The de-Empire migration (2026-07-09)
   dropped theme.js site-wide and left those buttons dead on the product page:
   the only way to change quantity was to type into the input by hand.

   This restores them: click +/- → step the input by its data-increment-value
   (fallback `step`, fallback 1), clamped to [min, max], then fire input + change
   so the <form> and any other listener see the new value. It also keeps Empire's
   cosmetic "minus dimmed at min" state in sync.

   Scope: only the product-form quantity input (name="quantity"). The redesigned
   /cart page has its own driver (fb-cart-page.js, [data-fb-cart-*] markup) and is
   intentionally left untouched. Delegated on document + idempotent, so it works
   for markup present at load or injected later, and never double-binds. */
(function () {
  'use strict';
  if (window.__fbQtyBound) return;
  window.__fbQtyBound = true;

  var SEL_WRAP = '[data-quantity-selector], quantity-selector';
  var SEL_INPUT = '[data-quantity-input]';
  var SEL_MINUS_WRAP = '[data-button-wrapper-minus]';
  var DISABLED = 'quantity-selector__button-wrapper--disabled';

  function toInt(v, fallback) {
    var n = parseInt(v, 10);
    return isNaN(n) ? fallback : n;
  }

  function isProductQty(input) {
    return !!input && input.getAttribute('name') === 'quantity';
  }

  function bounds(input) {
    var min = toInt(input.getAttribute('min'), 1);
    var maxAttr = input.getAttribute('max');
    var max = (maxAttr === null || maxAttr === '') ? null : toInt(maxAttr, null);
    var stp = toInt(input.getAttribute('data-increment-value'), toInt(input.getAttribute('step'), 1));
    if (stp < 1) stp = 1;
    return { min: min, max: max, step: stp };
  }

  function clamp(n, b) {
    if (n < b.min) n = b.min;
    if (b.max !== null && n > b.max) n = b.max;
    return n;
  }

  function syncMinus(wrap, input, b) {
    var mw = wrap.querySelector(SEL_MINUS_WRAP);
    if (!mw) return;
    mw.classList.toggle(DISABLED, toInt(input.value, b.min) <= b.min);
  }

  function stepBy(input, dir) {
    var b = bounds(input);
    var cur = toInt(input.value, b.min);
    var next = clamp(cur + dir * b.step, b);
    if (next !== cur) {
      input.value = next;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return b;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-quantity-plus], [data-quantity-minus]');
    if (!btn) return;
    var wrap = btn.closest(SEL_WRAP);
    if (!wrap) return;
    var input = wrap.querySelector(SEL_INPUT);
    if (!isProductQty(input)) return;
    e.preventDefault();
    var b = stepBy(input, btn.hasAttribute('data-quantity-plus') ? 1 : -1);
    syncMinus(wrap, input, b);
  });

  // Keep the dimmed-minus state honest when the shopper types a value directly.
  document.addEventListener('input', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches(SEL_INPUT) || !isProductQty(input)) return;
    var wrap = input.closest(SEL_WRAP);
    if (wrap) syncMinus(wrap, input, bounds(input));
  });
})();
